import { render, staticRenderFns } from "./QueryPolicyFireRisk.vue?vue&type=template&id=761207c4&"
import script from "./QueryPolicyFireRisk.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyFireRisk.vue?vue&type=script&lang=js&"
import style0 from "./QueryPolicyFireRisk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports